import { Outlet, useNavigate } from "react-router-dom";
import react, { useState } from "react";
import moment from "moment";
import "moment/locale/fr";
import { BackButton } from "../../../../_helpers/components/BackButton";

export const FicheContact = () => {
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("infos"); // "info" | "participants" | "historique"

    const statut = "actif"; // ou "archivé"

    const participationActivities = [
        {
            start: "2025-06-01T10:00:00",
            end: "2025-06-01T11:30:00",
            title: "Atelier peinture",
            lieu: "Salle polyvalente",
            participants: [
                { name: "Alice Dupont", status: "Oui" },
                { name: "Jean Martin", status: "Indécis" },
                { name: "Claire Robert", status: "Non" },
            ],
        },
        // ...
    ];
    const getBadge = (status) => {
        if (status === "actif") {
            return (
                <span className="ml-2 inline-block bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded-full">
                    Actif
                </span>
            );
        } else {
            return (
                <span className="ml-2 inline-block bg-gray-200 text-gray-700 text-xs px-2 py-0.5 rounded-full">
                    Archivé
                </span>
            );
        }
    };
    return (
        <div className="mx-auto p-6">
            <div className="flex justify-between">
                <BackButton
                    onClick={() => navigate("/activity/contacts")}
                    title="Retour aux contacts"
                />
                <div className="flex justify-end">
                    {" "}
                    <button
                        onClick={() => navigate("")}
                        className="p-2 rounded-full hover:bg-gray-100 transition"
                        title="Modifier"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 text-gray-700"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                            />
                        </svg>
                    </button>
                    <button
                        onClick={() => navigate("")}
                        className="p-2 rounded-full hover:bg-red-100 transition"
                        title="Affecter à un projet"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 text-app-primary"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 12a3 3 0 01-3 3h-1.5a3 3 0 110-6H12m6 0a3 3 0 01-3 3v0a3 3 0 003 3h1.5a3 3 0 000-6H18"
                            />
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 21v-2a4 4 0 014-4h2"
                            />
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 7a4 4 0 100-8 4 4 0 000 8z"
                            />
                        </svg>
                    </button>
                    <button
                        onClick={() => navigate("")}
                        className="p-2 rounded-full hover:bg-red-100 transition"
                        title="Supprimer"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 text-red-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 7L5 7M10 11v6M14 11v6M5 7l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"
                            />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200">
                <ul className="p-0 flex flex-wrap -mb-px">
                    <li className="me-2">
                        <button
                            onClick={() => setActiveTab("infos")}
                            className={`inline-block p-4 border-b-2 rounded-t-lg ${
                                activeTab === "infos"
                                    ? "text-blue-600 border-blue-600"
                                    : "border-transparent hover:text-gray-600 hover:border-gray-300"
                            }`}
                        >
                            Informations
                        </button>
                    </li>
                    <li className="me-2">
                        <button
                            onClick={() => setActiveTab("participations")}
                            className={`inline-block p-4 border-b-2 rounded-t-lg ${
                                activeTab === "participations"
                                    ? "text-blue-600 border-blue-600"
                                    : "border-transparent hover:text-gray-600 hover:border-gray-300"
                            }`}
                        >
                            Participations
                        </button>
                    </li>
                </ul>
            </div>
            <div className="mt-3 bg-white rounded-2xl shadow-xl p-6">
                <div className="flex flex-col md:flex-row items-start gap-6">
                    <img
                        src="https://media.istockphoto.com/id/1389348844/fr/photo/plan-de-studio-dune-belle-jeune-femme-souriante-debout-sur-un-fond-gris.jpg?s=612x612&w=0&k=20&c=VGipX3a8xrbYuXTNm_61pFuzpGdAO9lwt2xnVUd7Khs="
                        alt="Avatar"
                        className="w-24 h-24 rounded-full object-cover"
                    />
                    <div className="flex-1">
                        <h2 className="text-2xl font-bold">
                            Jean Dupont {getBadge(statut)}
                        </h2>
                        <p className="text-gray-600">
                            Responsable administratif - URSSAF
                        </p>
                        <hr />
                        {activeTab === "participations" && (
                            <div className="mt-8">
                                <div className="mt-8">
                                    <table className="min-w-full table-auto border rounded-sm overflow-hidden shadow-sm text-sm">
                                        <thead className="bg-gray-100 text-gray-700">
                                            <tr>
                                                <th className="px-4 py-2 text-left">
                                                    Date
                                                </th>
                                                <th className="px-4 py-2 text-left">
                                                    Titre
                                                </th>
                                                <th className="px-4 py-2 text-left">
                                                    Lieu
                                                </th>
                                                <th className="px-4 py-2 text-left">
                                                    Durée
                                                </th>
                                                <th className="px-4 py-2 text-left">
                                                    Participant
                                                </th>
                                                <th className="px-4 py-2 text-left">
                                                    Statut
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {participationActivities.flatMap(
                                                (activity, i) =>
                                                    activity.participants.map(
                                                        (participant, j) => (
                                                            <tr
                                                                key={`${i}-${j}`}
                                                                className="border-t hover:bg-gray-50 transition"
                                                            >
                                                                <td className="px-4 py-2">
                                                                    {moment(
                                                                        activity.start
                                                                    ).format(
                                                                        "DD/MM/YYYY HH:mm"
                                                                    )}
                                                                </td>
                                                                <td className="px-4 py-2">
                                                                    {
                                                                        activity.title
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-2">
                                                                    {activity.lieu ||
                                                                        "—"}
                                                                </td>
                                                                <td className="px-4 py-2">
                                                                    {moment(
                                                                        activity.end
                                                                    ).diff(
                                                                        moment(
                                                                            activity.start
                                                                        ),
                                                                        "minutes"
                                                                    )}{" "}
                                                                    min
                                                                </td>
                                                                <td className="px-4 py-2">
                                                                    {
                                                                        participant.name
                                                                    }
                                                                </td>
                                                                <td className="px-4 py-2">
                                                                    <span
                                                                        className={
                                                                            participant.status ===
                                                                            "Oui"
                                                                                ? "text-green-600"
                                                                                : participant.status ===
                                                                                  "Non"
                                                                                ? "text-red-600"
                                                                                : "text-yellow-600"
                                                                        }
                                                                    >
                                                                        {
                                                                            participant.status
                                                                        }
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )
                                                    )
                                            )}
                                            {participationActivities.length ===
                                                0 && (
                                                <tr>
                                                    <td
                                                        colSpan="6"
                                                        className="text-center text-gray-500 p-4"
                                                    >
                                                        Aucune participation
                                                        enregistrée.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                        {activeTab === "infos" && (
                            <>
                                {" "}
                                <div className="flex justify-between">
                                    <div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-2 text-sm">
                                            <Info label="Titre" value="M." />
                                            <Info
                                                label="Téléphone"
                                                value="06 12 34 56 78"
                                            />
                                            <Info
                                                label="Email"
                                                value="jean.dupont@urssaf.fr"
                                            />
                                            <Info
                                                label="Date de naissance"
                                                value="1985-05-12"
                                            />
                                            <Info
                                                label="Sexe"
                                                value="Masculin"
                                            />
                                            <Info
                                                label="Type"
                                                value="Intervenant RMN"
                                            />
                                            <Info
                                                label="Géré par"
                                                value="Médiation"
                                            />
                                            <Info
                                                label="Langue"
                                                value="Français"
                                            />
                                            <Info
                                                label="Adresse"
                                                value="123 Rue de l'Indépendance, 69000 Lyon, France"
                                            />
                                        </div>
                                        <div className="mt-4">
                                            <span className="font-semibold text-sm block mb-1">
                                                Projets rattachés
                                            </span>
                                            <div className="flex flex-wrap gap-2">
                                                {[
                                                    "Projet Alpha",
                                                    "Projet Beta",
                                                ].map((project) => (
                                                    <span
                                                        key={project}
                                                        className="bg-blue-100 text-blue-800 px-2 py-1 text-xs rounded-full"
                                                    >
                                                        {project}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <span className="font-semibold text-sm block mb-1">
                                                Publics
                                            </span>
                                            <div className="flex flex-wrap gap-2">
                                                {[
                                                    "Individuels",
                                                    "Famille",
                                                    "Cycle 3 (9-12 ans)",
                                                ].map((pub) => (
                                                    <span
                                                        key={pub}
                                                        className="bg-green-100 text-green-800 px-2 py-1 text-xs rounded-full"
                                                    >
                                                        {pub}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="mt-4">
                                            <span className="font-semibold text-sm block mb-1">
                                                Documents
                                            </span>{" "}
                                            <ul className="list-disc list-inside text-blue-700">
                                                {[
                                                    {
                                                        url: "https://",
                                                        nom: "Document 1 ",
                                                    },
                                                    {
                                                        url: "https://",
                                                        nom: "Document 3 ",
                                                    },
                                                    {
                                                        url: "https://",
                                                        nom: "Document 2 ",
                                                    },
                                                ].map((doc, index) => (
                                                    <li key={index}>
                                                        <a
                                                            href={doc.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="hover:underline"
                                                        >
                                                            {doc.nom}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="">
                                        <span className="font-semibold text-sm block mb-2">
                                            Participations aux projets
                                            (historique)
                                        </span>
                                        <div className="border-l-2 border-blue-600 pl-4 space-y-4">
                                            {[
                                                {
                                                    nom: "Projet Alpha",
                                                    date: "Janvier - Mars 2022",
                                                    commentaire:
                                                        "Au pied levé - Participation active, excellent retour des enseignants.",
                                                },
                                                {
                                                    nom: "Projet Gamma",
                                                    date: "Septembre - Décembre 2023",
                                                    commentaire:
                                                        "Au pied levé - Bonne implication, a su s’adapter aux contraintes du terrain.",
                                                },
                                            ].map((item, i) => (
                                                <div
                                                    key={i}
                                                    className="relative"
                                                >
                                                    <div className="absolute -left-[14px] top-1 w-3 h-3 bg-blue-600 rounded-full border-2 border-white"></div>
                                                    <div>
                                                        <h4 className="text-sm font-semibold text-gray-800">
                                                            {item.nom}
                                                        </h4>
                                                        <p className="text-xs text-gray-500">
                                                            {item.date}
                                                        </p>
                                                        <p className="text-sm text-gray-700 mt-1">
                                                            {item.commentaire}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>{" "}
                                </div>
                                <div className="mt-4">
                                    <span className="font-semibold text-sm block mb-1">
                                        Commentaire
                                    </span>
                                    <p className="text-sm text-gray-700 bg-gray-100 p-3 rounded-sm">
                                        Personne très réactive, à privilégier
                                        pour les demandes urgentes.
                                    </p>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const Info = ({ label, value }) => (
    <div className="flex">
        <span className="font-medium text-gray-600 mr-1">{label}:</span>
        <span className="text-gray-800">{value}</span>
    </div>
);
